import { createAction, props } from '@ngrx/store';

export const LoginSuccessAction = createAction(
    '[Login] Login Success',
    props<{ accessToken: string }>(),
);

export const LogoutAction = createAction('[Login] Logout');

export const SetAuthToken = createAction('[Login] authToken/set/success', props<{ authToken: string }>());
